export default {
    extract ( html ) {
        const fragment = document.createRange().createContextualFragment( html )
        const component = {}
        for (const c of fragment.querySelectorAll('template').values())
            component[c.id] = c
        return component
    },
}
